import request from '@/request/index';
import util from '@/libs/util';

//登录
export function AccountLogin(data) {
    return request({
        url: '/webapi/api/user_account/login',
        method: 'post',
        data
    });
}

//注册
export function AccountRegister(data) {
    return request({
        url: '/webapi/api/user_account/register',
        method: 'post',
        data
    });
}

//修改密码
export function AccountUpdataCipher(data) {
    return request({
        url: '/webapi/api/user_account/modify_pwd',
        method: 'PUT',
        data
    });
}

//校验用户是否存在
export function AccountChkexit(urlParms) {
    let parmas = (urlParms) ? '?' + (util.tool.urlPath(urlParms)) : "";
    return request({
        url: '/webapi/api/user_account/chk_exit/' + parmas,
        method: 'get'
    });
}

//找回密码
export function AccountforgetCipher(data) {
    return request({
        url: '/webapi/api/user_account/forgot_pwd',
        method: 'post',
        data
    });
}

//发送验证码
export function sendCode(data) {
    return request({
        url: '/webapi/api/service/send_phonecode',
        method: 'post',
        data
    });
} 